import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/shared/components/app/app';
import { BrowserRouter as Router } from 'react-router-dom';
import { initSentry } from '@/shared/services/sentry';
import './i18n';
import '@/shared/utils/dayjs-config';
import 'react-toastify/dist/ReactToastify.css';

initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
